<template>
    <div>
        <div v-show="showPageType == 0">
            <el-form
                ref="form"
                :inline="true"
                :model="query"
                class="query-form"
                size="mini"
            >
                <el-form-item label="ASIN:" class="query-form-item">
                    <el-input
                        v-model="query.asin"
                        placeholder="请输入ASIN"
                        style="width:160px"
                        clearable
                        @keyup.enter.native="searchForm"
                    ></el-input>
                </el-form-item>
                <el-form-item label="子ASIN:" class="query-form-item">
                    <el-input
                        v-model="query.sub_asin"
                        placeholder="请输入ASIN"
                        style="width:160px"
                        clearable
                        @keyup.enter.native="searchForm"
                    ></el-input>
                </el-form-item>
                <!--            <el-form-item label="国家：" class="query-form-item">-->
                <!--                <el-select-->
                <!--                    v-model="query.state"-->
                <!--                    ref="carrerSelect"-->
                <!--                    style="width: 100px;"-->
                <!--                    size="mini"-->
                <!--                    filterable-->
                <!--                    clearable-->
                <!--                    @change="getList"-->
                <!--                >-->
                <!--                    <el-option-->
                <!--                        v-for="item in us_arr"-->
                <!--                        :key="item.us"-->
                <!--                        :label="item.title"-->
                <!--                        :value="item.us"-->
                <!--                        :disabled="item.disabled"-->
                <!--                    >-->
                <!--                        <div class="keywords_arr_div">-->
                <!--                            <icon-svg-->
                <!--                                :icon-class="item.us"-->
                <!--                                style="font-size: 24px;margin-right:5px;"-->
                <!--                            ></icon-svg>-->
                <!--                            <span-->
                <!--                                style="font-weight: 700; font-size: 14px;margin-left: 10px;"-->
                <!--                            >{{ item.title }}</span-->
                <!--                            >-->
                <!--                        </div>-->
                <!--                    </el-option>-->
                <!--                </el-select>-->
                <!--            </el-form-item>-->
                <el-form-item label="负责人:" class="query-form-item">
                    <el-input
                        v-model="query.person"
                        placeholder="请输入负责人"
                        style="width:160px"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="店铺名称:" class="query-form-item">
                    <el-input
                        v-model="query.shop_name"
                        placeholder="请输入店铺名称"
                        style="width:160px"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="备注:" class="query-form-item">
                    <el-input
                        v-model="query.remark"
                        placeholder="请输入店铺名称"
                        style="width:160px"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                    <el-button
                        icon="el-icon-search"
                        type="primary"
                        @click="onSubmit"
                    >查询
                    </el-button
                    >
                </el-form-item>
                <el-form-item>
                    <el-button type="success" icon="el-icon-plus" @click="add"
                    >添加ASIN跟踪
                    </el-button
                    >
                    <!--                <el-button type="success" @click="onplural"-->
                    <!--                >查看词根单复数-->
                    <!--                </el-button-->
                    <!--                >-->
                    <el-button type="success" @click="nameList"
                    >店铺名称列表
                    </el-button
                    >
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                :data="list"
                size="mini"
                ref="multipleTable"
                class="table_content etyme_index"
                :row-key="getRowKeys"
                :expand-row-keys="expands"
                @row-click="clickRowHandle"
                @expand-change="clickRowHandle1"
                border
                style="width: 100%;"
                height='calc(100vh - 190px)'
            >
<!--                <el-table-column type="expand">-->
<!--                    <template slot-scope="props">-->
<!--                        <inline-->
<!--                            @getList="getList"-->
<!--                            :ref="'inline' + props.row.asin"-->
<!--                            :datasrow="props.row"-->
<!--                        ></inline>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column label="图片" width="120" align="center">
                    <template slot-scope="scope">
                        <el-popover placement="right" title>
                            <div
                                style="width: 100px;height: 100px;"
                                slot="reference"
                            >
                                <img
                                    style="width:100%;height:100%;"
                                    :src="scope.row.image_url"
                                />
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="父ASIN" width="150" align="center">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" :content="scope.row.curl_time" placement="top-start">
                            <div>
                                <span>{{ scope.row.asin }}</span>
                                <icon-svg
                                    :icon-class="scope.row.state"
                                    style="font-size: 24px;margin-left:5px;"
                                ></icon-svg>
                                <div v-if="scope.row.asin != null" @click.stop="edirectToAsin(scope.row)"
                                     style="cursor: pointer;color: rgb(52, 73, 94);">
                                    <i class="el-icon-s-promotion" style="margin-right:5px;"></i>{{ scope.row.asin }}
                                </div>
                            </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="钉钉提醒" width="100" align="center">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.is_dingding_warn == 1" @change="changeDingDingWarn(scope.row)"/>
                    </template>
                </el-table-column>
                <el-table-column label="品牌" width="100" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.brand }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="店铺" width="100" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.shop_name }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="负责人" width="100" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.person }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="备注" width="100" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.remark || '-' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="评分" width="100" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.score }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="ratings" width="100" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.ratings }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="排名" min-width="180" align="center">
                    <template slot-scope="scope">
                        <div class="fixedHeight">{{ scope.row.rank }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="标题" min-width="200" align="center">
                    <template slot-scope="scope">
                        <div class="fixedHeight">{{ scope.row.title }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="昨日变化" width="560" align="center">
                    <template slot-scope="scope">
                                            <div v-show="scope.row.change && !Array.isArray(scope.row.change)">

                                                <div>
                                                    <div class="ceil-span-title" style="height: 1px"></div>
                                                    <div class="ceil-span">总</div>
                                                    <div class="ceil-span">一星</div>
                                                    <div class="ceil-span">二星</div>
                                                    <div class="ceil-span">三星</div>
                                                    <div class="ceil-span">四星</div>
                                                    <div class="ceil-span">五星</div>
                                                </div>
                                                <br/>

                                                <div>
                                                    <div class="ceil-span-title">ratings:</div>
                                                    <template v-for="item in starArr">
                                                        <div class="ceil-span">{{ scope.row.change[`rating_${item}`] }}&nbsp;
                                                            <span class="ceil-span-change ceil-color_green"
                                                                  v-if="scope.row.change[`rating_${item}_change`] >= 0">( {{
                                                                    scope.row.change[`rating_${item}_change`]
                                                                }}<i
                                                                    class="el-icon-top"></i> )</span>
                                                            <span class="ceil-span-change ceil-color_red"
                                                                  v-else-if="scope.row.change[`rating_${item}_change`] < 0">( {{
                                                                    scope.row.change[`rating_${item}_change`]
                                                                }}<i class="el-icon-bottom"></i> )</span>
                                                            <span class="ceil-span-change" v-else style="height: 1px"></span>
                                                        </div>
                                                    </template>
                                                </div>
                                                <br/>

                                                <div>
                                                    <div class="ceil-span-title">reviews:</div>
                                                    <template v-for="item in starArr">
                                                        <div class="ceil-span">{{ scope.row.change[`review_${item}`] }}&nbsp;
                                                            <span class="ceil-span-change ceil-color_green"
                                                                  v-if="scope.row.change[`review_${item}_change`] >= 0">( {{
                                                                    scope.row.change[`review_${item}_change`]
                                                                }}<i
                                                                    class="el-icon-top"></i> )</span>
                                                            <span class="ceil-span-change ceil-color_red"
                                                                  v-else-if="scope.row.change[`review_${item}_change`] < 0">( {{
                                                                    scope.row.change[`review_${item}_change`]
                                                                }}<i class="el-icon-bottom"></i> )</span>
                                                            <span class="ceil-span-change" v-else style="height: 1px"></span></div>
                                                    </template>
                                                </div>
                                                <br/>
                                            </div>
                    </template>
                </el-table-column>

                <el-table-column label="操作" min-width="260" align="center" fixed="right">
                    <template slot-scope="scope">
                        <div @click.stop>

                            <el-button
                                    style="margin: 5px 0 5px 10px"
                                    size="mini"
                                    @click.native="gotoDetail(scope.row)"
                            >详情
                            </el-button>

                            <el-button
                                style="margin: 5px 0 5px 10px"
                                type="success"
                                size="mini"
                                @click.native="updateInfo(scope.row)"
                            >更新信息
                            </el-button>

                            <el-button
                                    style="margin: 5px 0 5px 10px"
                                    type="success"
                                    size="mini"
                                    @click.native="seeChange(scope.row)"
                            >评价趋势
                            </el-button>

                            <el-button
                                style="margin: 5px 0 5px 10px"
                                type="primary"
                                size="mini"
                                @click.native="downFile(scope.row)"
                            >评分导出
                            </el-button>
                            <el-button
                                style="margin: 5px 0 5px 10px"
                                type="primary"
                                size="mini"
                                @click.native="subAsinExport(scope.row)"
                            >子Asin详情导出
                            </el-button>
                            <el-button
                                style="margin: 5px 0 5px 10px"
                                type="danger"
                                size="mini"
                                @click.native="deleteItem(scope.row)"
                            >删除
                            </el-button>

                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :page-sizes="[10, 20, 50]"
                :total="query.total"
                background
                style="float: right;margin-top: 10px; margin-bottom: 5px"
                layout="total, sizes, prev, pager, next"
            >
            </el-pagination>
            <add
                :visible="ctrl.addDialogVisible"
                :title="'添加ASIN'"
                @close-callback="closeCllback"
            ></add>
            <upload
                :visible="ctrl.uploadDialogVisible"
                :formData="formData"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
            ></upload>
            <relevance
                ref="relevance"
                :visible="ctrl.relevanceDialogVisible"
                :formData="formData"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
            ></relevance>
            <upload1
                :visible="ctrl.upload1DialogVisible"
                :formData="formData"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
            ></upload1>
            <onremark
                :visible="ctrl.onremarkDialogVisible"
                :formData="formData"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
            ></onremark>
            <plural
                ref="plural"
                :visible="ctrl.pluralDialogVisible"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
            ></plural>
            <EditAdGroupName
                v-if="showAdGroup"
                :data="adGroupData"
                @close="closeAdGroupName"
                @onUpdate="onSubmit"
            />
            <RecordList
                title="列表记录"
                :formData="formData"
                v-if="ctrl.recordDialogVisible"
                :visible="ctrl.recordDialogVisible"
                @close-callback="closeCllback"
            />
            <sbvParseList
                :title="parse.title"
                :formData="formData"
                v-if="ctrl.sbvParseVisible"
                :visible="ctrl.sbvParseVisible"
                :type="parse.type"
                @close-callback="closeCllback"
            >
            </sbvParseList>
            <sdParseList
                title="SD广告组合解析列表"
                :formData="formData"
                v-if="ctrl.sdParseVisible"
                :visible="ctrl.sdParseVisible"
                @close-callback="closeCllback"
            >
            </sdParseList>
            <store-name-list :visible="this.ctrl.uploadFileListVisible" title="店铺名称列表"
                             @close-callback="closeCllback"></store-name-list>
            <updateInfoModal :visible="ctrl.updateVisible" :info="editInfo" :flagStr="labelStr"
                             @close-callback="closeCllback"/>
            <asinChangeModal :visible="ctrl.asinChangeModal" :info="editInfo" :flagStr="labelStr"
                             @close-callback="closeCllback"/>
            <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                              @close-callback="closeCllback" :closeFlag="true"></child-info-modal>
        </div>
        <view1 v-show="showPageType == 1" @goBackList="goBackList" ref="view1"></view1>
    </div>
</template>

<script>
import * as api from '@/api/Product/Product'
import {link_us} from '@/utils/method'
import Add from './add'
import Inline from './inline'
import Upload from './upload'
import Upload1 from './upload1'
import Onremark from './onremark'
import Plural from './plural'
import Onbutton from './onbutton'
import Relevance from './relevance'
import RecordList from './recordList'
import sbvParseList from './sbvParseList'
import sdParseList from './sdParseList'
import EditAdGroupName from './components/editAdGroupName'
import {binary_download, downloadFileUrl} from '@/utils/method'
import storeNameList from './storeNameList'
import updateInfoModal from '@/views/asinTailAfter/updateInfoModal.vue'
import asinChangeModal from '@/views/asinTailAfter/asinChangeModal.vue'
import ChildInfoModal from '@/views/asinTailAfter/childInfoModal.vue'
import {checkPlug} from '@/utils/method'
import {MessageBox} from 'element-ui'
import view1 from './view1.vue'

export default {
    components: {
        ChildInfoModal,
        Add,
        Upload,
        Inline,
        Onremark,
        Upload1,
        Plural,
        Relevance,
        Onbutton,
        EditAdGroupName,
        RecordList,
        sbvParseList,
        sdParseList,
        storeNameList,
        updateInfoModal,
        asinChangeModal,
        view1
    },
    data() {
        return {
            starArr: ['total', 1, 2, 3, 4, 5],
            parse: {
                title: '',
                type: ''
            },
            childInfo: {},
            adGroupData: null,
            showAdGroup: false,
            ctrl: {
                addDialogVisible: false,
                uploadFileListVisible: false,
                onremarkDialogVisible: false,
                pluralDialogVisible: false,
                upload1DialogVisible: false,
                relevanceDialogVisible: false,
                uploadDialogVisible: false,
                recordDialogVisible: false,
                sbvParseVisible: false,
                sdParseVisible: false,
                updateVisible: false,
                asinChangeModal: false,
                childInfoVisible: false,
            },
            us_arr: [
                {
                    us: 'US',
                    title: '美国'
                },
                {
                    us: 'UK',
                    title: '英国'
                },
                {
                    us: 'DE',
                    title: '德国'
                }
            ],
            expands: [],
            formData: {},
            query: {
                asin: '',
                sub_asin: '',
                state: '',
                person: '',
                shop_name: '',
                remark: '',
                page: 1,
                limit: 10
            },
            list: [],
            cList: [],
            disabled: false,
            loading: false,
            editInfo: {},
            labelStr: '',
            showPageType: 0,
        }
    },
    created() {
        this.getList()
    },
    mounted() {
        checkPlug(() => {
        }, () => this.$downLoadPlug())
    },
    methods: {
        goBackList() {
            this.showPageType = 0
        },
        seeChange(data) {
            this.editInfo = data
            this.ctrl.asinChangeModal = true
        },
        changeDingDingWarn(data) {
            MessageBox.confirm(`是否${data.is_dingding_warn == 1 ? '关闭' : '开启'}钉钉提醒`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                api.track_asin_index_update_dingding_warn({
                    id: data.id,
                    is_dingding_warn: data.is_dingding_warn == 1 ? 0 : 1,
                }).then(res => {
                    if (res.code === 0) {
                        this.$message({type: 'success', message: '更新成功'})
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(res => {
                    this.$message({type: 'error', message: res.message})
                })
            }).catch(() => {
            })
        },
        // 更新信息
        updateInfo(data) {
            api.track_asin_index_add_redis_for_parent_asin_base_message({
                id: data.id,
            }).then(res => {
                if (res.code === 0) {
                    this.$message({type: 'success', message: '更新成功'})
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(res => {
                this.$message({
                    type: 'error',
                    message: res.message
                })
            })
        },
        gotoDetail(data) {
            this.showPageType = 1
            this.$refs.view1.getList(data);
        },
        // 子asin详情导出
        subAsinExport(data) {
            api.track_asin_sub_sub_price_asin_details_export({
                id: data.id,
            }).then(res => {
                if (res.code === 0) {
                    if (!res.data) {
                        return this.$message({
                            type: 'error',
                            message: '无法下载！'
                        })
                    }
                    downloadFileUrl(res.data, data.shop_name)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(res => {
                this.$message({
                    type: 'error',
                    message: res.message
                })
            })
        },
        //删除
        deleteItem(data) {
            this.$confirm(`确定要删除这条数据吗?`, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                api.track_asin_index_delete({
                    id: data.id,
                }).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                        this.getList()
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                }).catch(res => {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                })
            })
                .catch(() => {
                })
        },
        searchForm() {
            this.getList()
        },
        // 获取row的key值
        getRowKeys(row) {
            return row.asin
        },
        getList() {
            this.loading = true
            return api.track_asin_index_index(this.query)
                .then(res => {
                    if (res.code === 0) {
                        this.cList = res.data.list
                        this.cList.forEach((item, index) => {
                            this.cList[index].rankInfo = {
                                rank_page_1: undefined,
                                rank_page_2: undefined,
                                rank_page_3: undefined
                            }
                            this.cList[index].rankChangeInfo = {
                                rank_page_1_change: undefined,
                                rank_page_2_change: undefined,
                                rank_page_3_change: undefined
                            }

                            this.cList[index].adChangeInfo = {
                                ad_rank_page_1_change: undefined,
                                ad_rank_page_2_change: undefined,
                                ad_rank_page_3_change: undefined
                            }
                            this.cList[index].adInfo = {
                                ad_rank_page_1: undefined,
                                ad_rank_page_2: undefined,
                                ad_rank_page_3: undefined
                            }
                        })
                        this.query.total = res.data.total
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                    this.list = this.cList
                    this.loading = false

                    // this.getPageTotal()
                })
                .catch(() => {
                    this.loading = false
                })
        },
        getPageTotal() {
            for (const index in this.cList) {
                api.seed_word_asin_get_three_page_total({id: this.cList[index].id}).then(res => {
                    if (res.code === 0) {
                        this.cList[index].rankInfo.rank_page_1 = res.data.rank_page_1
                        this.cList[index].rankInfo.rank_page_2 = res.data.rank_page_2
                        this.cList[index].rankInfo.rank_page_3 = res.data.rank_page_3
                        this.cList[index].adInfo.ad_rank_page_1 = res.data.ad_rank_page_1
                        this.cList[index].adInfo.ad_rank_page_2 = res.data.ad_rank_page_2
                        this.cList[index].adInfo.ad_rank_page_3 = res.data.ad_rank_page_3
                        this.cList[index].rankChangeInfo.rank_page_1_change = res.data.rank_page_1_change
                        this.cList[index].rankChangeInfo.rank_page_2_change = res.data.rank_page_2_change
                        this.cList[index].rankChangeInfo.rank_page_3_change = res.data.rank_page_3_change
                        this.cList[index].adChangeInfo.ad_rank_page_1_change = res.data.ad_rank_page_1_change
                        this.cList[index].adChangeInfo.ad_rank_page_2_change = res.data.ad_rank_page_2_change
                        this.cList[index].adChangeInfo.ad_rank_page_3_change = res.data.ad_rank_page_3_change

                        this.$set(this.list[index], 'rankInfo', {})
                        this.$set(this.list[index], 'adInfo', {})
                        this.$set(this.list[index], 'rankChangeInfo', {})
                        this.$set(this.list[index], 'adChangeInfo', {})

                        this.$set(this.list[index].rankInfo, 'rank_page_1', res.data.rank_page_1)
                        this.$set(this.list[index].rankInfo, 'rank_page_2', res.data.rank_page_2)
                        this.$set(this.list[index].rankInfo, 'rank_page_3', res.data.rank_page_3)
                        this.$set(this.list[index].adInfo, 'ad_rank_page_1', res.data.ad_rank_page_1)
                        this.$set(this.list[index].adInfo, 'ad_rank_page_2', res.data.ad_rank_page_2)
                        this.$set(this.list[index].adInfo, 'ad_rank_page_3', res.data.ad_rank_page_3)
                        this.$set(this.list[index].rankChangeInfo, 'rank_page_1_change', res.data.rank_page_1_change)
                        this.$set(this.list[index].rankChangeInfo, 'rank_page_2_change', res.data.rank_page_2_change)
                        this.$set(this.list[index].rankChangeInfo, 'rank_page_3_change', res.data.rank_page_3_change)
                        this.$set(this.list[index].adChangeInfo, 'ad_rank_page_1_change', res.data.ad_rank_page_1_change)
                        this.$set(this.list[index].adChangeInfo, 'ad_rank_page_2_change', res.data.ad_rank_page_2_change)
                        this.$set(this.list[index].adChangeInfo, 'ad_rank_page_3_change', res.data.ad_rank_page_3_change)

                        this.$set(this.list, index, JSON.parse(JSON.stringify(this.cList[index])))
                        this.$forceUpdate()
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                    this.$bus.$emit('auto_fit_state')
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        downloadAssociatedAds(data) {
            if (!data.relevance_file_path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            let obj = {
                file_path: data.relevance_file_path
            }
            //下载
            binary_download(
                '/apis/v1/common_file_export_by_path',
                'post',
                {},
                obj,
                'application/vnd.ms-excel',
                `${data.asin} 下载关联广告组数据.xlsx`
            )
        },
        //修改关联关系
        onRelevance(data) {
            if (data.ad_portfolio_name_id !== 0) {
                return
            }
            this.formData = JSON.parse(JSON.stringify(data))
            this.$refs.relevance.onList()
            this.$refs.relevance.onArr([...data.relevance_list])
            this.ctrl.relevanceDialogVisible = true
        },
        //更新
        ondetail(data) {
            this.loading = true
            api.update_asin_detail({
                asin: data.asin,
                state: data.state
            })
                .then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.getList()
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
                .catch(() => {
                    this.loading = false
                })
        },
        //跳转到内部竞价
        onJump(data, isNew = false) {
            // this.$router.push({
            //     path: "/adGroup/inside?asin=" + data.parent_asin
            // });
            this.$router.push({
                path: `/statistics/index?asin=${data.asin}&state=${data.state}&isNew=${isNew}&ad_portfolio_name_id=${data.ad_portfolio_name_id}`
                // query: data
            })
        },
        onSBJump(data, isNew = false) {
            // this.$router.push({
            //     path: "/adGroup/inside?asin=" + data.parent_asin
            // });
            this.$router.push({
                path: `/statisticsSB/index?asin=${data.asin}&state=${data.state}&isNew=${isNew}&ad_portfolio_name_id=${data.id}`
                // query: data
            })
        },
        //上传自动否定无效词根
        onupload(data) {
            this.formData = data
            this.ctrl.dialogTitle = data.asin + ' 上传自动否定无效词根'
            this.ctrl.upload1DialogVisible = true
        },
        //查看词根单复数
        onplural() {
            this.ctrl.dialogTitle = '查看词根单复数'
            this.ctrl.pluralDialogVisible = true
            this.$refs.plural.onSubmit()
        },
        // 店铺名称列表
        nameList() {
            this.ctrl.uploadFileListVisible = true
        },
        //添加备注
        addremark(data, str) {
            if (str == '负责人') {
                this.formData = {
                    res_person_value: data.res_person,
                    parent_asin: data.asin,
                    id: data.id
                }
            } else {
                this.formData = {
                    remark_value: data.remark,
                    parent_asin: data.asin,
                    id: data.id
                }
            }
            this.ctrl.onremarkDialogVisible = true
            this.ctrl.dialogTitle = str
        },
        //打开记录
        recordOpen(data) {
            this.formData = {
                parent_asin: data.asin,
                state: data.state,
                record_id: data.id,
            }
            this.ctrl.recordDialogVisible = true
        },
        sbvOpen(data, flag) {
            this.formData = {
                ad_portfolio_name: data.ad_portfolio_name,
                asin: data.asin,
                state: data.state,
            }
            if (flag) {
                this.parse.title = 'SBV广告组合解析列表'
                this.parse.type = 'SBV'
            } else {
                this.parse.title = 'SB广告组合解析列表'
                this.parse.type = 'SB'
            }
            this.ctrl.sbvParseVisible = true
        },
        sdOpen(data, flag) {
            this.formData = {
                ad_portfolio_name: data.ad_portfolio_name,
                asin: data.asin,
                state: data.state,
            }
            this.ctrl.sdParseVisible = true
        },
        //点击展开
        clickRowHandle(row, column) {
            if (['标题', '排名'].includes(column.label)) {
                this.childInfo = {
                    title: column.label,
                    info: column.label == '标题' ? row.title : column.label == '排名' ? row.rank : ''
                }
                this.ctrl.childInfoVisible = true
            } else if (['备注', '负责人', '店铺', '品牌'].includes(column.label)) {
                this.labelStr = column.label
                this.editInfo = row
                this.ctrl.updateVisible = true
            }
        },
        clickRowHandle1(row) {
            if (this.expands.includes(row.asin)) {
                this.expands = this.expands.filter(
                    val => val !== row.asin
                )
            } else {
                this.expands.push(row.asin)
                let str = 'inline' + row.asin
                let that = this
                setTimeout(function () {
                    that.$refs[str].handleClick()
                }, 10)
            }
        },
        //添加文件夹
        add() {
            this.ctrl.addDialogVisible = true
        },
        //上传词根数据
        on_file_upload(data, str) {
            this.formData = JSON.parse(JSON.stringify(data))
            this.ctrl.uploadDialogVisible = true
            this.ctrl.dialogTitle = str
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //重置
        onReset() {
            this.query.page = 1
            this.query.limit = 10
            this.query.asin = ''
            this.getList()
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.query.limit = 10
            this.getList()
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.uploadFileListVisible = false
            this.ctrl.addDialogVisible = false
            this.ctrl.uploadDialogVisible = false
            this.ctrl.onremarkDialogVisible = false
            this.ctrl.upload1DialogVisible = false
            this.ctrl.pluralDialogVisible = false
            this.ctrl.pluralDialogVisible = false
            this.ctrl.relevanceDialogVisible = false
            this.ctrl.recordDialogVisible = false
            this.ctrl.sbvParseVisible = false
            this.ctrl.sdParseVisible = false
            this.ctrl.updateVisible = false
            this.ctrl.asinChangeModal = false
            this.ctrl.childInfoVisible = false
            if (isshow) return
            this.getList()
        },
        bindAdGroupName(adGroupData) {
            this.showAdGroup = true
            this.adGroupData = adGroupData
        },
        closeAdGroupName() {
            this.showAdGroup = false
        },
        downFile(data) {
            api.track_asin_index_export({
                id: data.id,
            }).then(res => {
                if (res.code === 0) {
                    if (!res.data) {
                        return this.$message({
                            type: 'error',
                            message: '无法下载！'
                        })
                    }
                    downloadFileUrl(res.data, data.shop_name)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(res => {
                this.$message({
                    type: 'error',
                    message: res.message
                })
            })
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            // let url =
            //     link_us(data.state) +
            //     'dp/' +
            //     data.url_asin_href +
            //     '?th=1&psc=1'
            window.open(data.href_link, '_blank')
        },
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.ceil-span {
    margin-right: 5px;
    width: 70px;
    height: 18px;
    float: left;
    position: relative;
}

.ceil-span-title {
    width: 50px;
    text-align: right;
    float: left;

}

.ceil-span-change {
    margin-right: 5px;
    text-align: left;
    width: 50px;
    height: 18px;
    float: left;
    position: absolute;

}

.fixedHeight {
    height: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}

// .ceil-color {
//   color: #ff0000;
// }
.ceil-color_green {
    color: #00e640;
}

.ceil-color_red {
    color: #ff0000;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #fff !important;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    cursor: pointer;
    // background-color: rgb(221, 233, 255) !important;
    background-color: #fff !important;
}

/deep/ .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell[class*="cell"] {
    padding: 0 !important;
}

.pen:hover {
    cursor: pointer;
    text-decoration: underline;
}

.table_content {
    height: calc(100vh - 190px);
    overflow: auto;
    border: 1px solid #ebeef5;
}

/deep/ .el-table::before {
    display: none;
}
</style>
